import React from "react";
import * as Scrivito from "scrivito";
import { Container } from "reactstrap";
import { ObjValidator } from "components";
import { ProjectListHeader } from "./SubComponents/ProjectListHeader/ProjectListHeader";
import { ProjectListTable } from "./SubComponents/ProjectListTable/ProjectListTable";
import { ProjectListControls } from "./SubComponents/ProjectListControls/ProjectListControls";
import { ProjectListProvider } from "./providers/ProjectListProvider";

const ProjectList = Scrivito.connect(({ page }) => (
  <ProjectListProvider page={page}>
    <div className="position-relative bg-gray-100">
      <Container className="pb-8">
        <ProjectListHeader />
        <ProjectListControls />
        <ProjectListTable />
      </Container>
    </div>
  </ProjectListProvider>
));

const CheckedPage = (props) => (
  <ObjValidator {...props}>
    <ProjectList {...props} />
  </ObjValidator>
);
export default CheckedPage;
Scrivito.provideComponent("ProjectList", CheckedPage);
